/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsProductSection5 = {
  init: function ($section) {
    
    // Add settings from schema to current object
    window.PXUTheme.jsProductSection5 = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);
    
    this.desktopCircles = ["6.319","8.125","10.208","12.431","14.653","17.083","19.097","21.181","23.194","25.278","27.500","29.931","32.708","35.486","38.472","41.806","45.139","48.681","52.778"];
    this.mobileCircles = ["17.4359","22.5641","28.2051","34.3590","40.5128","47.1795","52.8205","58.4615","64.1026","69.7436","75.8974","82.5641","90.2564","97.9487","106.1538","115.3846","124.6154","134.3590","145.6410"];
    
    let imagesToDrawWaves = this.element.querySelectorAll(".Section_5--Image");
    for (let sectionImage of imagesToDrawWaves) {
      this.drawWaves(sectionImage);
    }
  },
  drawWaves(sectionImage) {

    let circlesWrapper = document.createElement("div");
    circlesWrapper.classList.add("Section_5--circles_wrapper");

    let circlesContainer = document.createElement("div");
    circlesContainer.classList.add("Section_5--circles_container");
    
    let circles = null;
    if (sectionImage.parentNode.classList.contains("Section_5--desktop_image")) {
      circles = this.desktopCircles;
    } else if (sectionImage.parentNode.classList.contains("Section_5--mobile_image")) {
      circles = this.mobileCircles;
    }

    let animationDelay = 0;
    let animationDuration = 3;
    let animationDelayStep = animationDuration / circles.length / 2;

    for (let circle of circles) {
      let circleElement = document.createElement("div");
      circleElement.classList.add("Section_5--circle");
      circleElement.style.width = `${circle}%`;

      circleElement.style.animationDelay = `${animationDelay}s`;
      circleElement.style.animationDuration = `${animationDuration}s`;
      
      animationDelay += animationDelayStep;

      circlesContainer.append(circleElement);
    }

    circlesWrapper.appendChild(circlesContainer);

    sectionImage.parentNode.append(circlesWrapper);
  }
}

/******/ })()
;